import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeAlert, RemoveFormattingIcon } from 'lucide-react';

const slides = [
  {
    id: 1,
    image: '/images/banner2.jpg',
    title: 'India’s Trusted Compliance Partner',
    subtitle:'We provide comprehensive compliance solutions including BIS Certification, WPC Approval, BEE Registration and more.',
  },
  {
    id: 2,
    image: '/images/mainbn.png', 
    // title: 'Leading BIS Certification Consultants in India',
    // subtitle: 'Helping you with ISI Mark, EPR, WPC, LMPC, and more — with ease and efficiency.',
  },
];

function Hero() {
  const [current, setCurrent] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000); 
    return () => clearInterval(timer);
  }, []);

  const currentSlide = slides[current];

  return (
    <section className="relative h-[200px] sm:h-[400px] md:h-[530px] overflow-hidden">
  {/* Background Overlay */}
  <div className="absolute inset-0 bg-black/20 z-10"></div>

  {/* Animated Background Image */}
  <AnimatePresence>
    {slides.map((slide, index) =>
      index === current ? (
        <motion.div
          key={slide.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="absolute inset-0 w-full h-full z-0"
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-center"
            loading="eager"
          />
        </motion.div>
      ) : null
    )}
  </AnimatePresence>

  {/* Text Content at Bottom */}
  <div className="relative z-20 h-full flex items-end justify-center text-center px-4 sm:px-6 md:px-12 pb-6 sm:pb-10">
    <div className="text-white max-w-[90%] sm:max-w-3xl">
      <motion.h1
        key={currentSlide.title}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-lg sm:text-xl md:text-4xl font-bold mb-2 sm:mb-4"
      >
        {currentSlide.title}
      </motion.h1>
      <motion.p
        key={currentSlide.subtitle}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        className="text-xs sm:text-sm md:text-lg text-gray-200"
      >
        {currentSlide.subtitle}
      </motion.p>
    </div>
  </div>
</section>

  );
}

export default Hero;

